var map = {
	"./pc-module-catalogue-1.vue": 99748,
	"./pc-module-catalogue-2.vue": 67508,
	"./pc-module-catalogue-3.vue": 60033,
	"./pc-module-catalogue-4.vue": 43077,
	"./pc-module-catalogue-5.vue": 42506,
	"./pc-module-catalogue-6.vue": 66386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5488;